export default {
  id: 'expense-wizard',
  title: 'Create Expense Report',
  category: 'Employee',
  summary: 'Choose the expense report type that matches how the cost will be approved and reimbursed or billed.',
  overview: 'Timeclerk supports three expense workflows. Pick the type that best matches the spend before you start entering line items.',
  howItWorks: [
    'Travel is for lodging, meals, mileage, and other costs incurred while traveling for work. You usually submit estimates before travel, then actuals afterward.',
    'Other Direct Costs are project- or customer-related charges such as materials or supplies that may be billable.',
    'General Business covers company expenses that are not travel-specific, such as office supplies or subscriptions.'
  ],
  actions: [
    {
      name: 'Select Travel',
      description: 'Starts a travel expense draft where you add locations, expense types, and estimated amounts.'
    },
    {
      name: 'Select Other Direct Costs',
      description: 'Starts an ODC request tied to a project or customer for review before purchase.'
    },
    {
      name: 'Select General Business',
      description: 'Starts a general business / purchase-request style report for non-travel company costs.'
    }
  ],
  tips: [
    'If the cost will be charged to a customer project, prefer Other Direct Costs over General Business.',
    'You can save drafts and return later from the Expenses list.'
  ],
  related: ['expenses', 'travel-expense', 'other-direct-costs', 'general-business']
};



// WEBPACK FOOTER //
// ./client/help/content/expense-wizard.js